/**
 * @returns {boolean}
 */
export function isStoragePersistSupported() {
  return (
    typeof navigator !== 'undefined' &&
    typeof navigator.storage?.persist === 'function');

}

/**
 * @returns {Promise<boolean>}
 */
export async function isStoragePersisted() {
  if (typeof navigator === 'undefined' || !navigator.storage?.persisted) {
    return false;
  }
  try {
    return await navigator.storage.persisted();
  } catch {
    return false;
  }
}

/**
 * Chiede al browser di non evictare facilmente IndexedDB / Cache (utile PWA offline).
 * @returns {Promise<{ supported: boolean, granted: boolean, persisted: boolean }>}
 */
export async function requestStoragePersistence() {
  if (!isStoragePersistSupported()) {
    return { supported: false, granted: false, persisted: false };
  }

  try {
    const already = await navigator.storage.persisted();
    if (already) {

      return { supported: true, granted: true, persisted: true };
    }

    const granted = await navigator.storage.persist();
    const persisted = granted || (await navigator.storage.persisted());



    return { supported: true, granted, persisted };
  } catch (err) {

    return { supported: true, granted: false, persisted: false };
  }
}